import * as React from 'react';
import { VscLoading } from '@react-icons/all-files/vsc/VscLoading';

export const Loader = (): JSX.Element => {
  return (
    <React.Fragment>
      <VscLoading />
    </React.Fragment>
  );
};
